import React from 'react';

// The most shops the note names; the rest are counted.
const ShownJobsMax = 10;

// Under the Finalize window's choice: the shops on the invoice that no longer pass the Ready for Invoicing rules, each
// with its id on its platform and why, as the window read them when it opened.
export default function FinalizeJobsNoLongerReadyNote({ jobs = [] }) {
  const shownJobs = jobs.slice(0, ShownJobsMax);
  const otherJobCount = jobs.length - shownJobs.length;
  const lead =
    jobs.length === 1
      ? '1 shop on this invoice no longer passes the Ready for Invoicing rules:'
      : `${jobs.length} shops on this invoice no longer pass the Ready for Invoicing rules:`;
  return (
    <div>
      <span>{lead}</span>
      <ul>
        {shownJobs.map((job) => (
          <li key={job.tpJobId}>
            {job.thirdPartyJobId ?? job.tpJobId}: {job.reason}
          </li>
        ))}
      </ul>
      {otherJobCount > 0 && <span>…and {otherJobCount} more.</span>}
    </div>
  );
}
